/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';
import MediaQueries from '../../constants/MediaQueries';

function Well({
  backgroundColor = Colors.GrayLight,
  children,
  style,
  className,
}: {
  backgroundColor?: string,
  children?: any,
  style?: Object,
  className?: string,
}) {
  return (
    <div className={names(Styles.Container, className)} style={{ backgroundColor, ...style }}>
      {children}
    </div>
  );
}

const Styles = {
  Container: css`
    padding: 56px 40px;
    max-width: 1360px;
    margin: 0 auto;
    ${MediaQueries.XLarge} {
      border-radius: 10px;
      padding: 80px 56px;
    }
  `,
};

export default Well;



// WEBPACK FOOTER //
// ./src/ui/components/core/Well.js